/**
 * Removes only the `neue-akte` query parameter from a URL, preserving all others.
 * Fix for Issue #873: previous cleanup wiped the entire search string.
 */
export function bereinigNeueAkteParam(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete('neue-akte');
  const remaining = params.toString();
  return remaining ? `${pathname}?${remaining}` : pathname;
}
